import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import CallAttemptSelectBox from 'components/molecules/call-attempts-select-box';

import s from './styles.module.scss';

import type { CallAttempt } from 'infrastructure/enums';

interface IProps {
  value: CallAttempt | null | undefined;
  onChange: (e?: CallAttempt) => void;
}

const CallAttemptsSelect: FC<IProps> = ({ onChange, value }) => {
  const { t } = useTranslation();

  return (
    <div className={s['available-billable-minutes-wrapper']}>
      <label data-cy="interactiveTimeDashboard-filter-callAttempts">
        {t('labels.callAttempts')}
      </label>
      <CallAttemptSelectBox
        withAll
        placeholder={t('labels.all')}
        value={value}
        onChange={onChange}
        allowClear
      />
    </div>
  );
};

export default CallAttemptsSelect;
